import { Form, Modal, Input, Select } from 'antd';
import { useEffect } from 'react';
import { UserMngItem } from '@/types/userMng';
import { useAtomValue } from 'jotai';
import { commonOptionsAtom } from '@/atoms/commonOptions';

export type UserTypeDialogType = 'batch' | 'single';

interface UserTypeDialogProps {
  type?: UserTypeDialogType;
  user?: UserMngItem;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (values: { userType: number; reason: string }) => void;
}

const UserTypeDialog = ({
  type,
  user,
  isOpen,
  onClose,
  onConfirm,
}: UserTypeDialogProps) => {
  const [form] = Form.useForm<{
    userType: number;
    reason: string;
  }>();

  const handleOk = () => {
    const values = form.getFieldsValue();
    onConfirm(values);
  };

  useEffect(() => {
    form.resetFields();
  }, [isOpen, form]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={type === 'single' ? `打标用户: ${user?.name}` : '批量打标'}
      okButtonProps={{
        type: 'primary',
        htmlType: 'submit',
      }}
      destroyOnClose
      modalRender={(node) => (
        <Form layout="vertical" form={form} onFinish={handleOk}>
          {node}
        </Form>
      )}
    >
      <div>
        <Form.Item
          label="用户类型"
          name="userType"
          required
          rules={[{ required: true, message: '请选择用户类型' }]}
        >
          <Select>
            {useAtomValue(commonOptionsAtom).userTypes.map((type) => (
              <Select.Option key={type.value} value={type.value}>
                {type.text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="打标理由"
          name="reason"
          required
          rules={[{ required: true, message: '请输入打标理由' }]}
        >
          <Input.TextArea rows={4} maxLength={200} />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default UserTypeDialog;
